import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../shared/services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { IAEventDocumentDetails } from '../../../../../shared/models/IAEventDocumentDetails';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { CommonService } from '../../../../../shared/services/common.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { IAEventAttendanceDetails } from '../../../../../shared/models/IAEventAttendanceDetails';

@Component({
  selector: 'app-viewmsmedocuments',
  templateUrl: './viewmsmedocuments.component.html',
  styleUrl: './viewmsmedocuments.component.css'
})
export class ViewmsmedocumentsComponent implements OnInit {
  private loadEventAttendanceSubscription: Subscription | null = null;
  private destroy$: Subject<void> = new Subject<void>();
  UniqueEventId: string | null = null;
  userType = sessionStorage.getItem('UserType');
  statusList: any[] = [];
  eventId: any;
  length: number = 0;
  AttendanceDetailsData: any[] = [];
  pageSize: number = 20;
  pageIndex = 0;
  pageEvent!: PageEvent;

  pageSizeOptions: number[] = [10, 20, 50, 100];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;

  DtoPagination =
    {
      "UniqueEventId": '',

      "PageNumber": 1,
      "PageSize": 20,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": ""
    }
  
  dataSourceattendance!: MatTableDataSource<IAEventAttendanceDetails>
  displayedAttendanceColumns: string[] = ['SrNo', 'UdyamRegistrationNumber', 'CreatedDate'];
  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  constructor(private apiService: ApiService, private commonService: CommonService,
    public dialogRef: MatDialogRef<ViewmsmedocumentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.UniqueEventId = data?.UniqueEventId || null;  // Get msmeid from data
    if (this.userType === 'MSSIDC') {
      
      //alert(data.msmeUserId);
      this.UniqueEventId = data?.UniqueEventId 
    }
  }
  form1 = new FormGroup({

    searchControl: new FormControl('', [Validators.pattern(this.commonService.searchFilter)])

  })

  ngOnInit(): void {
    this.loadStatusAndRemarks();    
  }
  ngAfterViewInit() {
    
    this.loadEventIAAttendanceWithUdyamDetails();
  } 
  loadStatusAndRemarks() {    
    if (this.userType === 'MSSIDC') {
      var dtoUniqueEventId = {
        UniqueEventId: this.UniqueEventId
      }      
      this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETIADOCUMENTS, dtoUniqueEventId).subscribe(
        result => {
          if (result.status) {
            this.statusList = result.data;
          }
        }
      );
    }
  }
  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }
  closeDialog(): void {
    this.dialogRef.close();  // Close the dialog
  }

  loadEventIAAttendanceWithUdyamDetails() {
    

     //this.eventId = this.UniqueEventId;
    //this.DtoPagination.UniqueEventId = this.UniqueEventId ?? '';
    this.DtoPagination.UniqueEventId = this.UniqueEventId as string;
    if (!this.pagination) return;
    // Unsubscribe from previous subscription to prevent multiple API calls
    if (this.loadEventAttendanceSubscription) {
      this.loadEventAttendanceSubscription.unsubscribe();
    }

    this.loadEventAttendanceSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;

          return this.apiService
            .getRequest(API_ENDPOINTS.IA.GETEVENTIAATTENDANCEWITHUDYAM, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            this.length = resp['totalRecords'];
          }
          return resp?.data || {};
        })
      )
      .subscribe(data => {
        this.AttendanceDetailsData = data;
        this.adjustPaginator();
      });
  }
  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }
  onSearchChange(e: any) {
    this.DtoPagination.SearchTerm = e.target.value;
    this.DtoPagination.PageNumber = 1;
    this.loadEventIAAttendanceWithUdyamDetails();
  }
  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.loadEventIAAttendanceWithUdyamDetails();
  }

  onSearchClick(searchValue: string): void {
    const searchControl = this.form1.get('searchControl');


    if (searchControl?.value && searchValue.trim() !== '') {
      this.DtoPagination.SearchTerm = searchValue.trim();
      this.loadEventIAAttendanceWithUdyamDetails();
    } else if (searchValue.trim() === '') {
      searchControl?.markAsTouched();
    } else {
      searchControl?.markAsTouched();
    }
  }
}
